import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _apiCount = 0;
  private _isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this._isLoadingSubject.asObservable();

  showLoader() {
    if (this._apiCount === 0) {
      this._isLoadingSubject.next(true);
    }
    this._apiCount++;
  }

  hideLoader() {
    this._apiCount--;
    if (this._apiCount === 0) {
      this._isLoadingSubject.next(false);
    }
  }
}
